import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import { CreditCardTypes } from 'app/models/ss-api/responses/credit.card.response';


@Pipe({ name: 'creditCardType' })
export class CreditCardTypePipe implements PipeTransform {

    transform(value: CreditCardTypes, args: any[]): string {

        switch ( value ) {
            case CreditCardTypes.AmericanExpress :
                return "amex";
            
            case CreditCardTypes.DinersClub :
                return "diners";
            
            case CreditCardTypes.Discover :
                return "discover";

            case CreditCardTypes.EnRoute :
                return "enroute";

            case CreditCardTypes.JCB :
                return "jcb";

            case CreditCardTypes.MasterCard :
                return "mastercard";

            case CreditCardTypes.VISA :
                return "visa";

            default :
                return "unknown";

        }



    }

}
